module.exports = __webpack_public_path__ + "assets/images/premium-features/auto-assigning-8f15c2.svg";